import { WSFileAccessScope } from "@wingspanhq/files/dist/lib/interfaces";
import { useDownloadFile } from "../../../query/files/mutations";

export const useFileDownload = () => {
  const [downloadFile, downloadFileMeta] = useDownloadFile();

  const download = async (
    fileId: string,
    accessScope = WSFileAccessScope.Private
  ) => {
    await downloadFile({ accessScope, fileId });
  };

  return { download, isLoading: downloadFileMeta.isLoading };
};
